/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const SAVE_RAW_EVENT = gql`
  mutation SaveRawEvent($input: SaveRawEventInput!) {
    saveRawEvent(input: $input)
  }
`;
